import {
  cart
} from "./chunk-9v1sdekd.js";

// src/components/cart-count-v2/count.ts
class CartCountV2 extends HTMLElement {
  subscription = null;
  connectedCallback() {
    this.subscription = cart.subscribe((state) => {
      this.show(state.itemCount);
    });
  }
  disconnectedCallback() {
    this.subscription?.unsubscribe();
    this.subscription = null;
  }
  show(itemCount) {
    this.textContent = String(itemCount);
    this.classList.toggle("is-empty", itemCount === 0);
  }
}
var registerCartCountV2 = () => {
  if (customElements.get("cart-count-v2") === undefined) {
    customElements.define("cart-count-v2", CartCountV2);
  }
};

// src/components/cart-count-v2/index.ts
registerCartCountV2();
